export interface RadioData {
  name: string;
}
